import { useCallback } from 'react';
import { useProductContext } from '..';
import { useSessionUserInput } from '../../..';
export var ActiveProductProvider = function ActiveProductProvider(_ref) {
  var children = _ref.children;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct,
    getDefaultAIConfig = _useProductContext.getDefaultAIConfig;
  var _useSessionUserInput = useSessionUserInput(),
    showSearchAIDialog = _useSessionUserInput.showSearchAIDialog,
    toggleShowSearchAIDialog = _useSessionUserInput.toggleShowSearchAIDialog;
  var onCloseAIDialog = useCallback(function () {
    toggleShowSearchAIDialog(false);
  }, [toggleShowSearchAIDialog]);
  var defaultAIConfig = getDefaultAIConfig();
  return children({
    activeProduct: getActiveProduct(),
    showSearchAIDialog: showSearchAIDialog,
    onCloseAIDialog: onCloseAIDialog,
    defaultAIConfig: defaultAIConfig
  });
};